import {FC} from 'react';
import DemoRegistration from '../../components/DemoRegistration';

const DemoRegistrationPage: FC = () => {
  return <DemoRegistration />;
};

export default DemoRegistrationPage;
